"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = require("styled-components");
var SvgLoading_1 = __importDefault(require("../Icon/SvgLoading"));
var Button = function (props) {
    var children = props.children, theme = props.theme, variant = props._variant, special = props.special, size = props.size, fullWidth = props.fullWidth, color = props.color, darkModeProp = props.darkMode, loading = props.loading, disabled = props.disabled, compact = props.compact, onClick = props.onClick, className = props.className, forwardedRef = props.forwardedRef, top = props.top, right = props.right, bottom = props.bottom, left = props.left, BtnComp = props._BtnComp, others = __rest(props, ["children", "theme", "_variant", "special", "size", "fullWidth", "color", "darkMode", "loading", "disabled", "compact", "onClick", "className", "forwardedRef", "top", "right", "bottom", "left", "_BtnComp"]);
    var btnRef = forwardedRef || react_1.default.createRef();
    var doesBtnContainIconOnly = react_1.default.useMemo(function () { return variant === 'icon-only' || variant === 'fab-icon'; }, [variant]);
    var isBtnForDarkMode = react_1.default.useMemo(function () { return darkModeProp && (variant === 'contained' || variant === 'outlined'); }, [darkModeProp, variant]);
    var resolvedClassNames = react_1.default.useMemo(function () {
        return clsx_1.default({
            '_ndsBtn--large': size === 'l' || special === 'price',
            '_ndsBtn--medium': size === 'm' && !doesBtnContainIconOnly,
            '_ndsBtn--fluid': fullWidth,
            '_ndsBtn--compact': compact,
            '_ndsBtn--icon': doesBtnContainIconOnly,
            '_ndsBtn--destructive': color === 'destructive' && !darkModeProp,
            '_ndsBtn--grey': color === 'grey' && !darkModeProp,
            '_ndsBtn--loading': loading && !disabled,
            '_ndsBtn--price': special === 'price',
            '_ndsBtn--dark-mode': isBtnForDarkMode
        }, className);
    }, [
        size,
        fullWidth,
        doesBtnContainIconOnly,
        color,
        loading,
        disabled,
        special,
        className,
        compact,
        darkModeProp,
        isBtnForDarkMode
    ]);
    var loadingIconAttrs = react_1.default.useMemo(function () {
        var iconColor = theme.ColorIconButtonDefaultBase;
        if (color === 'grey') {
            iconColor = theme.ColorIconButtonDefaultGrey;
        }
        if (color === 'destructive') {
            iconColor = theme.ColorIconButtonDefaultError;
        }
        switch (variant) {
            case 'contained':
                if (isBtnForDarkMode) {
                    iconColor = theme.ColorFontButtonContainedDarkBase;
                }
                else {
                    iconColor =
                        color === 'grey' ? theme.ColorIconButtonContainedGrey : theme.ColorFontWhite;
                }
                break;
            case 'fab':
            case 'fab-icon':
                iconColor =
                    color === 'grey' ? theme.ColorIconButtonContainedGrey : theme.ColorFontWhite;
                break;
            case 'outlined':
                if (isBtnForDarkMode) {
                    iconColor = theme.ColorFontButtonOutlinedDarkBase;
                }
                break;
            default:
        }
        if (special === 'price') {
            iconColor = theme.ColorIconButtonDefaultPrice;
        }
        return {
            color: iconColor
        };
    }, [theme, color, variant, special, isBtnForDarkMode]);
    var handleOnClick = react_1.default.useCallback(function (event) {
        if (onClick != undefined && !disabled) {
            onClick(event);
        }
    }, [onClick, disabled]);
    var handleOnMouseUp = react_1.default.useCallback(function () {
        if (btnRef.current) {
            btnRef.current.blur();
        }
    }, [btnRef]);
    var prepareButtonContent = function () {
        var content;
        if (loading) {
            var loadingAnimatedIconSize = 's';
            if (doesBtnContainIconOnly) {
                loadingAnimatedIconSize = size === 'l' ? 'l' : 'm';
            }
            else if (size === 'm' || size === 'l' || special === 'price') {
                loadingAnimatedIconSize = 'm';
            }
            content = [
                react_1.default.createElement("div", { key: 1, className: "icon" },
                    react_1.default.createElement(SvgLoading_1.default, __assign({ size: loadingAnimatedIconSize }, loadingIconAttrs))),
                doesBtnContainIconOnly ? null : 'Loading...'
            ];
        }
        if (disabled) {
            content = children;
        }
        return content;
    };
    var buttonContent = prepareButtonContent() || children;
    return (react_1.default.createElement(BtnComp, __assign({ ref: btnRef, onMouseUp: handleOnMouseUp, onClick: handleOnClick }, ((disabled || loading) && { disabled: true }), { className: resolvedClassNames, color: color, top: top, right: right, bottom: bottom, left: left }, others), buttonContent));
};
exports.ButtonRootComp = Button;
Button.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]),
    _variant: prop_types_1.default.oneOf(['outlined', 'contained', 'icon-only', 'fab', 'fab-icon']),
    special: prop_types_1.default.oneOf(['price']),
    size: prop_types_1.default.oneOf(['s', 'm', 'l']),
    color: prop_types_1.default.oneOf(['destructive', 'grey']),
    darkMode: prop_types_1.default.bool,
    loading: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    compact: prop_types_1.default.bool,
    fullWidth: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    className: prop_types_1.default.string,
    top: prop_types_1.default.string,
    right: prop_types_1.default.string,
    bottom: prop_types_1.default.string,
    left: prop_types_1.default.string,
    forwardedRef: prop_types_1.default.any,
    theme: prop_types_1.default.any,
    _BtnComp: prop_types_1.default.any
};
Button.defaultProps = {
    children: null,
    _variant: undefined,
    special: undefined,
    size: 's',
    color: undefined,
    darkMode: false,
    loading: false,
    disabled: false,
    compact: false,
    fullWidth: false,
    onClick: null,
    className: undefined,
    top: undefined,
    right: undefined,
    bottom: undefined,
    left: undefined,
    forwardedRef: null,
    theme: {},
    _BtnComp: null
};
exports.default = styled_components_1.withTheme(Button);
//# sourceMappingURL=Button.js.map